// NewItemLineDialog.js - Dialog for creating new item lines
import { useState } from 'react';
import '../newCustomerDialog.css';
import { authFetchRequest, getCookie } from './AppearanceCommon';

const NewItemLineDialog = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    id: '',
    product_type: '',
    label: '',
    description: '',
    condition: '',
    template: '',
    expressions: '',
    order_place: '',
    active: true,
    topic: '',
    topic_number: '',
    q_number: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.id || !formData.product_type) {
      alert('ID and Product Type are required!');
      return;
    }
    try {
      const newItem = await authFetchRequest('/appearance-templates/', formData, 'POST',
        { Authorization: `Bearer ${getCookie("access_token")}` }
      );
      onClose(newItem);
    } catch (error) {
      console.error('Error creating item line:', error);
      alert('Failed to create item line');
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h2>New Item Line Setup</h2>
        <form onSubmit={handleSubmit}>

          <div className="form-group-dialog">
            <label>
              ID: <span style={{color: 'red'}}>*</span>
              <input
                type="text"
                name="id"
                value={formData.id}
                onChange={handleChange}
                placeholder="e.g. window_price"
                required
              />
            </label>
          </div>

          {/* ROW 1: Product Type + Label — same line */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'end' }}>
            <div style={{ flex: '0 0 23%' }}>
              <label>Product Type: <span style={{color: 'red'}}>*</span></label>
              <input
                type="text"
                name="product_type"
                value={formData.product_type}
                onChange={handleChange}
                placeholder="e.g. window"
                style={{ width: '100%' }}
                required
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Label:</label>
              <input
                type="text"
                name="label"
                value={formData.label}
                onChange={handleChange}
                placeholder="e.g. Price"
                style={{ width: '100%' }}
              />
            </div>
          </div>

          {/* ROW 2: Topic + Topic # + Q # + Order + Active */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'end' }}>
            <div style={{ flex: '0 0 300px' }}>
              <label>Topic:</label>
              <input
                type="text"
                name="topic"
                value={formData.topic}
                onChange={handleChange}
                placeholder="e.g. Main, Glass"
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ flex: '0 0 70px' }}>
              <label>Topic #:</label>
              <input
                type="number"
                name="topic_number"
                value={formData.topic_number}
                onChange={handleChange}
                min="0"
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ flex: '0 0 70px' }}>
              <label>Q #:</label>
              <input
                type="number"
                name="q_number"
                value={formData.q_number}
                onChange={handleChange}
                min="0"
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ flex: '0 0 70px' }}>
              <label>Order:</label>
              <input
                type="number"
                name="order_place"
                value={formData.order_place}
                onChange={handleChange}
                min="0"
                placeholder="10"
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ flex: '0 0 80px', display: 'flex', alignItems: 'center', paddingBottom: '8px' }}>
              <label className="label-checkbox" style={{ margin: 0 }}>
                <input
                  type="checkbox"
                  name="active"
                  checked={formData.active}
                  onChange={handleChange}
                />
                Active
              </label>
            </div>
          </div>

          {/* Rest of the form */}
          <div className="form-group-dialog">
            <label>Description:</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="2"
              placeholder="Optional description"
            />
          </div>

          <div className="form-group-dialog">
            <label>Condition (JS expression):</label>
            <textarea
              name="condition"
              value={formData.condition}
              onChange={handleChange}
              rows="3"
              placeholder="e.g. item.type === 'casement'"
            />
          </div>

          <div className="form-group-dialog">
            <label>Template (HTML/JSX):</label>
            <textarea
              name="template"
              value={formData.template}
              onChange={handleChange}
              rows="5"
              placeholder="<div>{{item.price}}</div>"
            />
          </div>

          <div className="form-group-dialog">
            <label>Expressions (JSON):</label>
            <textarea
              name="expressions"
              value={
                typeof formData.expressions === 'object' && formData.expressions !== null
                  ? JSON.stringify(formData.expressions, null, 2)
                  : String(formData.expressions || '')
              }
              onChange={handleChange}
              rows="4"
              placeholder='{ "final_price": "item.price * 0.9" }'
            />
          </div>

          <div className="form-actions">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit">Create Item Line</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewItemLineDialog;
